<template>
  <b-row>
    <b-col cols="12">
      <event-table />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import EventTable from './EventTable.vue'

export default {
  components: {
    BRow,
    BCol,

    EventTable
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>